
import SwiperWrapper from '@/js/modules/SwiperWrapper'
import NavBar from '@/js/modules/NavBar'
import Action from '@/js/modules/Action'

window.APP_MODULES = {
    SwiperWrapper,
    NavBar,
    Action,
}
